var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 14.6667C9.1665 15.9553 10.2112 17 11.4998 17H13.6665C15.0472 17 16.1665 15.8807 16.1665 14.5C16.1665 13.1193 15.0472 12 13.6665 12H11.6665C10.2858 12 9.1665 10.8807 9.1665 9.5C9.1665 8.11929 10.2858 7 11.6665 7H13.8332C15.1218 7 16.1665 8.04467 16.1665 9.33333M12.6665 5.5V7M12.6665 17V18.5M22.6665 12C22.6665 17.5228 18.1894 22 12.6665 22C7.14366 22 2.6665 17.5228 2.6665 12C2.6665 6.47715 7.14366 2 12.6665 2C18.1894 2 22.6665 6.47715 22.6665 12Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyDollarCircle);
export default __webpack_public_path__ + "static/media/currency-dollar-circle.91f03871ca74d1ed1395920095dc9780.svg";
export { ForwardRef as ReactComponent };